namespace SorAraBul.PropertyManagement {
    export interface TenantDetailHasoPinRequest extends Serenity.ServiceRequest {
        EntityId?: string;
        PinCode?: string;
    }
}
